import { useMemo } from 'react';

export const useLeftSidebarController = ({
  // Prefab State
  prefabs,
  visiblePrefabs,
  selectedPrefabId,
  prefabSearchTerm,
  editingPrefabId,
  editingName,

  // Hierarchy State
  activeNodes,
  selectedNodeIds,
  containerNode,
  collapsedNodeIds,

  // Prefab Operations
  prefabOps,
  dragDrop,

  // Hierarchy Operations
  hierarchyOps,
  interactionHandlers,

  // Actions
  setPrefabSearchTerm,
  setSelectedPrefabId,
  setSelectedNodeIds,
  setEditingPrefabId,
  setEditingName,
  toggleNodeExpansion,
  pushContext,
  clearSelection,
  nodeOps
}) => {
  const controller = useMemo(() => ({
    // Prefab data
    prefabs,
    visiblePrefabs,
    selectedPrefabId,
    prefabSearchTerm,
    editingPrefabId,
    editingName,

    // Prefab handlers
    onPrefabSearchChange: setPrefabSearchTerm,
    onPrefabSelect: (id) => {
      setSelectedPrefabId(id === selectedPrefabId ? null : id);
    },
    onPrefabDoubleClick: (e, id) => {
      e.stopPropagation();
      const prefab = prefabs.find((p) => p.id === id);
      if (prefab && prefab.defaultWidth && prefab.defaultHeight) {
        pushContext(id, prefab.defaultWidth, prefab.defaultHeight);
        clearSelection();
      }
    },
    onPrefabRename: (id, name) => {
      setEditingPrefabId(id);
      setEditingName(name);
    },
    onPrefabDelete: prefabOps.handleDeletePrefab,
    onPrefabEditNameChange: (e) => setEditingName(e.target.value),
    onPrefabEditNameBlur: () => prefabOps.handleRenamePrefab(editingPrefabId, editingName),
    onPrefabEditNameKeyDown: (e) => {
      if (e.key === 'Enter') {
        prefabOps.handleRenamePrefab(editingPrefabId, editingName);
      } else if (e.key === 'Escape') {
        setEditingPrefabId(null);
      }
    },
    onPrefabDragStart: dragDrop.handleDragStart,
    onPrefabDragEnd: dragDrop.handleDragEnd,

    // Hierarchy data
    nodes: activeNodes,
    selectedNodeIds,
    rootId: containerNode?.id,
    collapsedNodeIds,

    // Hierarchy handlers
    onHierarchySelect: setSelectedNodeIds,
    onHierarchyMove: hierarchyOps.handleHierarchyMove,
    onHierarchyUpdate: (id, updates) => nodeOps.handlePropertyUpdate(updates, [id]),
    onContextMenuAction: hierarchyOps.handleContextMenuAction,
    onFocusItem: interactionHandlers.handleFocusItem,
    onToggleNodeExpansion: toggleNodeExpansion
  }), [
    prefabs,
    visiblePrefabs,
    selectedPrefabId,
    prefabSearchTerm,
    editingPrefabId,
    editingName,
    activeNodes,
    selectedNodeIds,
    containerNode,
    collapsedNodeIds,
    prefabOps,
    dragDrop,
    hierarchyOps,
    interactionHandlers,
    setPrefabSearchTerm,
    setSelectedPrefabId,
    setSelectedNodeIds,
    setEditingPrefabId,
    setEditingName,
    toggleNodeExpansion,
    pushContext,
    clearSelection,
    nodeOps
  ]);

  return controller;
};
